<template>
    <div>
<!--        "<strong>{{ $_.get(activity, "payload.name") }}</strong>" The role of-->
<!--        <strong>{{ $_.get(activity, "actorUser.name") }}</strong> has been removed.-->
        <span v-html="$t('notification.roleRemoved', { user: $_.get(activity, 'actorUser.name'), role:$_.get(activity, 'payload.name') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "RoleRemoved",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
